var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftNofill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.519 4.319 C 2.743 6.233,1.290 7.810,1.290 7.823 C 1.290 7.836,1.442 7.988,1.627 8.160 C 1.813 8.332,1.965 8.487,1.965 8.505 C 1.965 8.523,1.813 8.678,1.627 8.850 C 1.442 9.022,1.290 9.174,1.290 9.187 C 1.290 9.217,7.740 16.170,7.769 16.170 C 7.797 16.170,9.210 14.853,9.210 14.826 C 9.210 14.814,8.108 13.616,6.761 12.164 L 4.311 9.525 10.901 9.517 L 17.490 9.510 17.490 8.505 L 17.490 7.500 10.901 7.493 L 4.311 7.485 6.761 4.846 C 8.108 3.394,9.210 2.196,9.210 2.184 C 9.210 2.157,7.797 0.840,7.769 0.840 C 7.757 0.840,6.295 2.406,4.519 4.319 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftNofill);
export default __webpack_public_path__ + "static/media/arrowLeft_nofill.c2b3df6f02aac0f182914297ee1b1a0c.svg";
export { ForwardRef as ReactComponent };